export * from './public_api';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /app/~/angularfire2/database/index.js
// module id = ../../../../angularfire2/database/index.js
// module chunks = 7